import { Add, Delete } from "@mui/icons-material";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import NewRangePicker from "@/shared/forms/NewRangePicker";
import dayjs from "dayjs";
import { ProjectPhaseDowntime } from "../Project";

export default function DowntimeTab({ downtimes, onChange }: {
  downtimes: ProjectPhaseDowntime[];
  onChange: (downtimes: ProjectPhaseDowntime[]) => void;
}) {
  const active = downtimes.filter((downtime) => !downtime.deleted);
  const update = (index: number, changes: Partial<ProjectPhaseDowntime>) => {
    const target = active[index];
    onChange(downtimes.map((downtime) => downtime === target ? { ...downtime, ...changes, changed: true } : downtime));
  };

  return <Box sx={{ p: 2, overflow: "auto", flex: 1 }}>
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
      <Typography variant="h6">Stillstandszeiten</Typography>
      <Button startIcon={<Add />} variant="contained" onClick={() => onChange([...downtimes, {
        id: 0, startDate: dayjs().format("YYYY-MM-DD"), endDate: dayjs().format("YYYY-MM-DD"), comment: "", deleted: false,
      }])}>Stillstand hinzufügen</Button>
    </Box>
    {active.length === 0 ? <Typography color="text.secondary">Für diese Bauphase sind keine Stillstände erfasst.</Typography> : null}
    {active.map((downtime, index) => <Box key={downtime.id || index} sx={{ display: "flex", alignItems: "center", gap: 2, py: 1.5, borderBottom: "1px solid #ddd" }}>
      <NewRangePicker small value={[dayjs(downtime.startDate), dayjs(downtime.endDate)]} onChange={([start, end]) => update(index, {
        startDate: start?.format("YYYY-MM-DD") ?? downtime.startDate,
        endDate: end?.format("YYYY-MM-DD") ?? downtime.endDate,
      })} />
      <TextField size="small" fullWidth label="Begründung / Beschreibung" value={downtime.comment} onChange={(event) => update(index, { comment: event.target.value })} />
      <IconButton color="error" aria-label="Stillstand löschen" onClick={() => update(index, { deleted: true })}><Delete /></IconButton>
    </Box>)}
  </Box>;
}
